import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Requester from '../../store/blueprint/svc';
import Alert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import LoaderWithProgress from '../atoms/loader/LoaderWithProgress';
import { invokePostService, invokeGetService, handleSnackBar } from '../../store/global/actions';
import { Grid, Typography, CircularProgress, InputBase, Button, Tooltip, List, ListItem, ListItemIcon, ListItemText, IconButton } from '@material-ui/core';
import { CheckCircle } from '@material-ui/icons';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import { useMonaco } from '@monaco-editor/react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { getBuildStatus } from '../../store/global/selectors';
import BlockIcon from '@material-ui/icons/Block';

const AU = require('ansi_up');
const ansi_up = new AU.default();

const fetch = new Requester();
const useStyles = makeStyles((theme) => ({
    search: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        marginLeft: '12px !important',
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(1),
            width: 'auto',
        },
        border: '1px solid #ccc',
    },
    filterDiv: {
        fontColour: '#ccc',
        height: '100%',
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
    },
    inputRoot: {
        color: 'inherit',
        border: '1px solid #ccc', // Add border to the input root
        borderRadius: theme.shape.borderRadius, // Add border radius
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
        display: 'flex',
        flexGrow: 1,
        borderRadius: theme.shape.borderRadius, // Add border radius
    },
    noResult: {
        margin: '10px 12px',
        fontColour: '#ccc',
        fontWeight: 400
    },
    filterBtn: {
        fontSize: 14,
        fontWeight: 600,
        textTransform: 'none',
        color: '#737373',
        focusRipple: 'none'
    },
    dropdownMenu: {
        marginTop: "34px",
    },
    dropdownMenuPaper: {
        borderRadius: "4px",
        border: "solid 1px #ccc",
        boxShadow: 'none'
    },
    topHeading: {
        marginTop: 4,
        marginBottom: 4,
        display: 'flex',
        justifyContent: 'space-between'
    },
    labelDivStyle: {
        marginTop: "15px",
    },
    terminateBtn: {
        marginTop: "15px",
        marginRight: "5px"
    },
    searchContainer: {
        marginTop: 4,
        marginBottom: 4,
    },
    logContainer: {
        height: '50vh',
        width: '100%',
        overflowY: 'auto',
        backgroundColor: '#1e1e1e',
        color: '#d4d4d4',
        padding: '10px',
        fontFamily: 'monospace',
        whiteSpace: 'pre-wrap'
    },
    logEntry: {
        padding: '5px 0',
        fontSize: "12px",
        marginBottom: "-9px"
    },
    highlighted: {
        backgroundColor: 'yellow'
    },
    searchBar: {
        marginTop: 4,
        marginBottom: 4,
        display: 'flex',
        justifyContent: "flex-end",
    },
    success: {
        color: 'green',
        fontWeight: 'bold',
    },
    error: {
        color: '#f17575',
        fontWeight: 'bold',
    },
    noResultLabel: {
        marginLeft: theme.spacing(1),
        alignSelf: 'center',
    },
    disabledIcon: {
        color: '#ccc !important', // Grey out the icon when disabled
    },
}));
const pageSize = 100;

export default function BuildOutput({ item }) {

    const activeOne = { color: 'red', cursor: 'pointer' };
    const completedStatus = ['completed', 'failed', 'terminated'];

    const classes = useStyles();
    const editorRef = useRef(null);
    const offSet = useRef(0);
    const dispatch = useDispatch();
    const monaco = useMonaco();

    const buildStatus = useSelector(getBuildStatus);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [activeBatch, setActiveBatch] = useState(null);
    const [activeLogs, setActiveLogs] = useState('');
    const [enableTermination, setEnableTermination] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [terminatingSimulation, setTerminatingSimulation] = useState(false);
    const [totalLogs, setTotalLogs] = useState(0);
    const [searchedQuery, setSearchedQuery] = useState('');
    const [searchIndex, setSerchIndex] = useState(0);
    const [noSearchResult, setNoSearchResult] = useState(false);
    const [editor, setEditor] = useState(null);
    const logContainerRef = useRef(null);
    const [searchDir, setSearchDir] = useState('');
    const [indices, setIndices] = useState({ startIndex: 0, endIndex: 0 })
    const [totalMatches, setTotalMatches] = useState(0);


    const countOccurrences = (searchText) => {
        const logElements = logContainerRef.current.querySelectorAll('.log-entry');
        let totalOccurrences = 0;

        logElements.forEach((element) => {
            const innerText = element.innerText;
            const regex = new RegExp(searchText, 'gi');
            const matches = innerText.match(regex);
            if (matches) {
                totalOccurrences += matches.length;
            }
        });

        return totalOccurrences;
    };


    const highlightText = (searchText, searchVal) => {
        if (!searchedQuery) return;
        let searchIndexValue = searchVal != undefined ? searchVal : searchIndex

        const logElements = logContainerRef.current.querySelectorAll('.log-entry');
        let matchedCount = 0;

        logElements.forEach((element) => {
            const innerText = element.innerText;
            const regex = new RegExp(`(${searchText})`, 'gi');

            element.innerHTML = innerText.replace(regex, (match, p1, offset) => {
                matchedCount++;
                if (matchedCount === searchIndexValue) {
                    console.log("Test1111------->", matchedCount, searchIndexValue)

                    return `<span class="highlighted">${match}</span>`;
                } else {
                    return match; // Return the original match if not the desired index
                }
            });
        });

        if (searchIndexValue > 0) {
            const firstMatch = logContainerRef.current.querySelector('.highlighted');
            if (firstMatch) {
                firstMatch.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }

    };


    const changeSearchIndex = (dir) => {
        if (searchedQuery == '') {
            setNoSearchResult(true)
            return
        }

        setSearchDir(dir)

        if (dir === 'next') {
            let nextSearch = searchIndex + 1
            const totalOccurrences = countOccurrences(searchedQuery)
            setTotalMatches(totalOccurrences)

            if (searchIndex > totalOccurrences - 1) {
                if (currentPage <= Math.ceil(totalLogs / pageSize) - 1) {
                    setNoSearchResult(false)
                    searchBatchLogs(activeBatch?._id, searchedQuery, dir, indices.startIndex, indices.endIndex, offSet.current)
                        .then((searchResults) => {
                            if (searchResults.logs.length == 0) {
                                setNoSearchResult(true)
                            }
                            else {
                                setIndices({ startIndex: searchResults.startIndex, endIndex: searchResults.endIndex })
                                setCurrentPage(searchResults.page);
                                const logMessages = searchResults.logs.map(log => log.log);
                                setActiveLogs(logMessages.join("\n"));
                                setSerchIndex(1);
                                highlightText(searchedQuery, 1);

                            }
                        })
                        .catch((error) => {
                            console.log('Error:', error);
                        })
                } else {
                    setNoSearchResult(true)
                    setSerchIndex(searchIndex); // Set search index to the last occurrence
                }
            } else {
                setNoSearchResult(false)
                setSerchIndex(nextSearch);
                highlightText(searchedQuery, nextSearch);
            }
        } else if (dir === 'prev') {
            let prevSearch = searchIndex - 1;

            if (prevSearch < 1) {
                if (currentPage > 0) {
                    setNoSearchResult(false);
                    searchBatchLogs(activeBatch?._id, searchedQuery, dir, indices.startIndex, indices.endIndex, offSet.current)
                        .then((searchResults) => {
                            if (searchResults.logs.length == 0) {
                                setNoSearchResult(true)
                            }
                            else {
                                setIndices({ startIndex: searchResults.startIndex, endIndex: searchResults.endIndex })
                                setCurrentPage(searchResults.page);
                                const logMessages = searchResults.logs.map(log => log.log);
                                setActiveLogs(logMessages.join("\n"));
                                setSerchIndex(1);
                                highlightText(searchedQuery, 1);
                            }

                        })
                        .catch((error) => {
                            console.error('Error:', error);
                        })

                } else {
                    setNoSearchResult(true)
                    setSerchIndex(0); // Set search index to the first occurrence
                    highlightText(searchedQuery, prevSearch);
                }
            } else {
                setNoSearchResult(false)
                setSerchIndex(prevSearch);
                highlightText(searchedQuery, prevSearch);
            }
        }
    };


    const fetchData = async () => {
        try {
            setLoading(true);
            dispatch(invokeGetService('getSimulationBatches', [], true))
                .then((logBatches) => {
                    setData(logBatches?.batches ? logBatches.batches : []);
                    setLoading(false);
                    let runningBatches = logBatches?.batches.filter(batch => batch?.status == "running") || [];
                    let latestBatch = null;
                    if (runningBatches?.length > 0) {
                        setEnableTermination(true)
                        latestBatch = runningBatches[0];
                    }
                    else {
                        latestBatch = logBatches?.batches?.[0];
                    }
                    if (logBatches?.batches?.length > 0) {
                        setActiveBatch(latestBatch);
                        fetchBatchLogs(latestBatch._id).then((logs) => {

                            if (logs?.logs?.length > 0) {
                                offSet.current = offSet.current + logs?.logs?.length;
                            }
                            setTotalLogs(logs?.count ? logs?.count : 0)
                            const totalPages = Math.ceil(logs?.count / pageSize);
                            setCurrentPage(totalPages - 1)
                            const logMessages = logs.logs.map(log => log.log);
                            setActiveLogs(logMessages.join("\n"));
                            if (logContainerRef.current) {
                                logContainerRef.current.scrollTop = logContainerRef.current.scrollHeight;
                            }

                        })

                    }
                })
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const searchBatchLogs = async (batchId, searchText, dir, startInd, endInd, offSetVal) => {
        try {
            return dispatch(invokeGetService('searchBatchLogs', [batchId, searchText, dir, startInd, endInd, offSetVal], true))
                .then((searchResults) => {
                    return searchResults;
                })
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }


    const fetchBatchLogs = (batchId, skipValue) => {
        if (skipValue === undefined) skipValue = -1;
        return dispatch(invokeGetService('getBatchLogs', [batchId, skipValue, pageSize], true))
            .then((logs) => {
                setIndices({ startIndex: logs.startIndex, endIndex: logs.endIndex })
                return logs;
            })
            .catch(error => {
                console.error("Error :", error)
            })
    };


    useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `.highlighted {background-color: yellow !important;}`;
        document.head.appendChild(style);
        fetchData();
    }, []);

    useEffect(() => {
        let intervalId;

        if (activeBatch && !completedStatus.includes(activeBatch.status)) {
            intervalId = setInterval(() => {
                fetchBatchLogs(activeBatch._id, offSet.current)
                    .then((logs) => {
                        if (logs && logs.batch && completedStatus.includes(logs.batch.status) && logs.logs.length == 0) {
                            setEnableTermination(false)
                            clearInterval(intervalId);
                            setData(prevData =>
                                prevData.map(batch =>
                                    batch._id === logs.batch._id ? { ...batch, status: logs.batch.status } : batch
                                )
                            );
                            offSet.current = 0;
                            if (logs.batch.status == 'terminated') setActiveLogs(prevLogs => prevLogs + "\n" + "[error]Simulation Terminated[/error]");

                        }
                        else {
                            if (logs?.logs?.length > 0) {
                                offSet.current = offSet.current + logs?.logs?.length;
                            }
                            setEnableTermination(true)
                            const logMessages = logs.logs.map(log => log.log);
                            setActiveLogs(prevLogs => prevLogs + "\n" + logMessages.join("\n"));
                            if (logContainerRef.current) {
                                logContainerRef.current.scrollTop = logContainerRef.current.scrollHeight;
                            }
                        }
                    })
                    .catch(error => {
                        console.error('Error fetching batch logs:', error);
                    });
            }, 3000);
        }

        return () => clearInterval(intervalId);
    }, [activeBatch]);


    const changeContent = (batch) => {
        setActiveBatch(batch)
        setActiveLogs('');
        setCurrentPage(0) // Reset the offset
        setSearchedQuery('')
        offSet.current = 0;
        fetchBatchLogs(batch._id).then((logs) => {
            setTotalLogs(logs?.count ? logs?.count : 0)
            const totalPages = Math.ceil(logs?.count / pageSize);
            setCurrentPage(totalPages - 1)
            const logMessages = logs.logs.map(log => log.log);
            setActiveLogs(logMessages.join("\n"));
            if (logContainerRef.current) {
                logContainerRef.current.scrollTop = logContainerRef.current.scrollHeight;
            }

        })
    }

    const handlePageChange = (direction) => {
        let newPage;
        setSerchIndex(0)
        switch (direction) {
            case 'prev':
                if (currentPage > 0) {
                    newPage = currentPage - 1;
                } else {
                    return;
                }
                break;
            case 'next':
                const maxPage = Math.ceil(totalLogs / pageSize) - 1;
                if (currentPage < maxPage) {
                    newPage = currentPage + 1;
                } else {
                    return;
                }
                break;
            default:
                return;
        }

        fetchBatchLogs(activeBatch?._id, newPage * pageSize)
            .then((logs) => {
                const logMessages = logs.logs.map(log => log.log);
                setActiveLogs(logMessages.join("\n"));
                scrollToDown();
                setCurrentPage(newPage);
            })
            .catch(error => {
                console.log("Error:", error);
            });
    }



    const terminateSimulation = () => {
        setTerminatingSimulation(true);
        dispatch(invokePostService('terminateSimulation', { batch: activeBatch }, [], true))
            .then((response) => {
                if (response.status && response.data === 0) {
                    dispatch(handleSnackBar({ open: true, message: "Simulation terminated", severity: 'success' }));
                }
                setTerminatingSimulation(false);
            })
    }

    const getStatusIcon = (status) => {
        const iconStyle = { fontSize: '16px' };
        switch (status) {
            case 'running':
                return <CircularProgress size={16} />;
            case 'completed':
                return <CheckCircle style={{ ...iconStyle, color: 'green' }} />;
            case 'failed':
                return <CancelOutlinedIcon style={{ ...iconStyle, color: 'red' }} />;
            case 'terminated':
                return <BlockIcon style={{ ...iconStyle, color: '#808080' }} />;
            default:
                return null;
        }
    };

    const onSearchBuildFiles = (event) => {
        setSearchedQuery(event.target.value);
    }


    const parseAnsiString = (str) => {
        const regex = /\u001b\[(\d+)m(.*?)\u001b\[([0-9;]*m)?/g;
        const parts = [];
        let lastIndex = 0;
        str.replace(regex, (match, code, text, offset, a) => {
            //console.log({match, code, text, offset, a})
            if (lastIndex < a) {
                parts.push(str.substring(lastIndex, a));
            }
            parts.push(`<span class="${classes.success}">${text}</span>`);
            lastIndex = a + match.length;
        });
        if (lastIndex < str.length) {
            parts.push(str.substring(lastIndex));
        }
        return parts;
    };

    const getColorFromAnsiCode = (code) => {
        switch (code) {
            case '31':
                return 'red';
            case '33':
                return 'yellow';
            default:
                return 'black';
        }
    };
    const processLogLine = (line, classes) => {

        const successRegex = /\[success\](.*?)\[\/success\]/gi;
        const errorRegex = /\[error\](.*?)\[\/error\]/gi;
        var bpidRegex = /<bpid>(.*?)<\/bpid>/;
        var quoteRegex = /"/gi;
        var colourCodeRegx = /\\u001b\[[0-9]{1,2}m/gi;
        var newLineRegex = /hbx_newline/gi;

        // let pline = line.replace(bpidRegex, '').replace(quoteRegex, '').trim();
        let processedLine = line;
        processedLine = processedLine.replace(successRegex, `<span class="${classes.success}">$1</span>`);
        processedLine = processedLine.replace(errorRegex, `<span class="${classes.error}">$1</span>`);
        processedLine = processedLine.replace(bpidRegex, '');
        processedLine = processedLine.replace(quoteRegex, '');
        processedLine = processedLine.replace(colourCodeRegx, '');
        processedLine = processedLine.replace(newLineRegex, '\n');
        // processedLine = parseString(processedLine);
        return processedLine;
    };

    const scrollToDown = () => {
        if (logContainerRef.current) {
            logContainerRef.current.scrollTop = logContainerRef.current.scrollHeight;
        }
    }

    const isPrevDisabled = currentPage === 0;
    const isNextDisabled = (currentPage + 1) * pageSize >= totalLogs;



    return (
        <Grid container direction={"row"} spacing={3}>

            {loading && <Grid item xs={12} style={{ padding: 15 }}>
                <LoaderWithProgress size={12} isContent={true} isLoader={true} />
            </Grid>}
            {data?.length === 0 && loading === false && buildStatus && 
            <Grid item xs={12} style={{height: '50vh', border: '1px solid #ccc', padding: 15 }}>
                <Alert severity="warning">No simulation logs found.</Alert>
            </Grid>}
            {data?.length === 0 && loading === false && !buildStatus && 
            <Grid item xs={12} style={{height: '50vh', border: '1px solid #ccc', padding: 15 }}>
                <Alert severity="warning">Blueprint is not built/deployed.</Alert>
            </Grid>}

            {data != undefined && data?.length > 0 &&
                <>
                    <Grid item xs={3}>
                        {data.length > 0 ?
                            <List id="logsList">
                                {data.map(batch => <ListItem key={batch?._id} style={batch.label == activeBatch?.label ? activeOne : { cursor: 'pointer' }} onClick={e => changeContent(batch)}>
                                    <Tooltip title={batch.status == "running" ? "Running" : batch.status == "failed" ? "Failed" : batch.status == "terminated" ? "Terminated" :"Completed"} arrow>
                                        <ListItemIcon style={{ minWidth: '30px' }}>
                                            {getStatusIcon(batch?.status)}
                                        </ListItemIcon>
                                    </Tooltip>
                                    <ListItemText primary={batch.label} />
                                </ListItem>)}
                            </List>
                            :
                            <Typography className={classes.noResult}>
                                No result found
                            </Typography>
                        }

                    </Grid>
                    <Grid item xs={9}>
                        {!enableTermination && < Grid item xs={12} className={classes.topHeading} id={"simulationPagination"}>
                            <Tooltip title="Previous" arrow>
                                <IconButton onClick={() => { handlePageChange("prev") }} disabled={isPrevDisabled}>
                                    <KeyboardArrowLeftIcon color="primary" />
                                </IconButton>
                            </Tooltip>
                            <Grid item className={classes.labelDivStyle}>
                                <Typography id={"simulation_log_heading"} variant='h6'>
                                    {activeBatch ? activeBatch.label : ""}
                                </Typography>
                            </Grid>
                            <Tooltip title="Next" arrow>
                                <IconButton onClick={() => { handlePageChange("next") }} disabled={isNextDisabled}>
                                    <KeyboardArrowRightIcon color="primary" />
                                </IconButton>
                            </Tooltip>

                        </Grid>}
                        {enableTermination && <Grid item xs={12} className={classes.topHeading}>
                            <Grid item className={classes.labelDivStyle}>
                                <Typography id={"simulation_log_heading"} variant='h6'>
                                    {activeBatch ? activeBatch.label : ""}
                                </Typography>
                            </Grid>
                            <Grid item className={classes.terminateBtn}>
                                <Button onClick={terminateSimulation} color="primary" style={{textTransform: 'capitalize'}} variant="contained" disabled={terminatingSimulation}>
                                    Terminate Simulation
                                </Button>
                            </Grid>
                        </Grid>}
                        < Grid item xs={12} className={classes.searchBar}>
                            <InputBase
                                placeholder="Search"
                                classes={{
                                    root: classes.inputRoot,
                                    input: classes.inputInput,
                                }}
                                onChange={onSearchBuildFiles}
                                inputProps={{ 'aria-label': 'search' }}
                                id="searchField"
                                style={{ minWidth: "250px" }}
                            />
                            <Tooltip title="Previous Match" arrow>
                                <IconButton onClick={() => { changeSearchIndex("prev") }} disabled={searchedQuery == ''} className={searchedQuery === '' ? classes.disabledIcon : ''}
                                >
                                    <ExpandLessIcon color="primary" />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Next Match" arrow>
                                <IconButton onClick={() => { changeSearchIndex("next") }} disabled={searchedQuery == ''} className={searchedQuery === '' ? classes.disabledIcon : ''}>
                                    <ExpandMoreIcon color="primary" />
                                </IconButton>
                            </Tooltip>
                            {noSearchResult && <Typography variant="body2" color="error" className={classes.noResultLabel}>
                                No result
                            </Typography>}
                        </Grid>
                        <Grid item xs={12}>
                            {/* {activeBatch != '' && <Editor
                                height="90vh"
                                defaultLanguage="lua"
                                language={fileType}
                                theme="vs-dark"
                                path={activeBatch?.label}
                                value={activeLogs}
                                loading="Loading content.."
                                onMount={handleEditorDidMount}
                            />} */}
                            <div ref={logContainerRef} className={classes.logContainer} id={"simulationLogContainer"}>
                                {activeLogs.split('\n').map((line, index) => (
                                    // <div key={index} className={`${classes.logEntry} log-entry`}>
                                    //     {line}
                                    // </div>
                                    <div key={index} className={`${classes.logEntry} log-entry`} dangerouslySetInnerHTML={{ __html: processLogLine(line, classes) }} />

                                ))}
                            </div>
                        </Grid>

                    </Grid>
                </>}
        </Grid >
    )
}